import { PreferenceService } from "../sdServices/preferenceSvc";
import { PathResolutionService } from "../sdServices/asset-path-resolution/path-resolution-service";
import { SectionIdDefaultValue } from "../preference/preferenceController";

/**
 * Interface to for usage to return an instance of stop for howler currentlyPlayingSound
 */
export interface CurrentlyPlayingSound {
  stop(): void;
}

/**
 * Audio service. This is a singleton instance which can be used by controllers/services
 */
export interface AudioService {
  /**
   * A function to lookup a sound preference value (utilizing the preference service) and attempt to play it
   * @param preferenceKey The key of the preference that points to a source audio file to play.
   * @param appId The application ID that the preference should be loaded from.
   * @param sectionId Optional parameter to specify a specific section the preference should be loaded from.
   */
  playPreference(preferenceKey: string, appId: string, sectionId?: string): CurrentlyPlayingSound;

  /**
   * A function to play a sound by name or Uri.
   * @param audioNameOrUri The name or uri of the audio file to play.
   */
  play(audioNameOrUri: string): CurrentlyPlayingSound;
}

interface HowlWithIndex {
  [audioNameOrUri: string]: Howl;
}

export class AudioServiceImplementation implements AudioService {
  private audioHowls: HowlWithIndex = {};

  // @ngInject
  constructor(
    private preferenceService: PreferenceService,
    private assetPathResolutionService: PathResolutionService
  ) {}

  public play(audioNameOrUri: string): CurrentlyPlayingSound {
    let absoluteAudioNameOrUri = this.assetPathResolutionService.resolvePath(audioNameOrUri, (audioNameOrUri: any) => {
      return audioNameOrUri && audioNameOrUri.endsWith(".mp3");
    });
    if (this.audioHowls && this.audioHowls[absoluteAudioNameOrUri] && absoluteAudioNameOrUri) {
      this.audioHowls[absoluteAudioNameOrUri].play();
    } else if (absoluteAudioNameOrUri) {
      let audio = new Howl({ src: [absoluteAudioNameOrUri] });
      this.audioHowls[absoluteAudioNameOrUri] = audio;
      audio.play();
    }

    return this.audioHowls[absoluteAudioNameOrUri];
  }

  public playPreference(preferenceKey: string, appId: string, sectionId?: string): CurrentlyPlayingSound {
    this.preferenceService.getPreference(appId, sectionId || SectionIdDefaultValue).then((preferences: any) => {
      if (preferences && preferences.content[preferenceKey]) {
        return this.play(preferences.content[preferenceKey]);
      }
    });
    return undefined;
  }
}
